



















































































import { Component, Vue, PropSync, Prop, Watch } from 'vue-property-decorator';
import { institutionServer, professionServer, spaceServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: {},
})
export default class ProfessionEdit extends Vue {
  @PropSync('flag', Number) pageFlag!: number; // 显示哪个页面flag
  @Prop(String) row!: string; // 传递给编辑页面的表单数据对象
  antiShake = true; // 防抖判断
  showWhatFlag = true; // 展示哪个页面：编辑或新增
  // 表单数据对象
  formData: object = {
    name: '', // 岗位名称
    spaceName: undefined, // 空间名称
    sort: '', // 排序号
  };
  // 表单验证规则对象
  formRules: object = {
    name: [{ required: true, trigger: 'change', message: '必填信息' }],
    spaceName: [{ required: true, trigger: 'change', message: '必填信息' }],
    sort: [{ required: true, trigger: 'change', validator: this.sortValidator }],
  };

  dialogVisible = false; // 控制 dialog 是否显示
  dialogTitle = ''; // dialog 的标题
  searchOrgan = ''; // 搜索机构输入框
  checkNode: any = null; // 选中的节点数据
  // 树节点数据
  treeData: any[] = [];
  // dialog 中树形图的属性
  defaultProps: object = {
    children: 'children',
    label: 'name',
  };

  /**
   * @todo 后期需要优化的部分
   * @desc Vue数据加载生命周期函数
   * @param1 无
   * @returns 无
   */
  async created() {
    if (this.pageFlag === 2) {
      professionServer
        .getLineData(this.row)
        .then((res: any) => {
          this.formData = res.data;
        })
        .catch((error: any) => {
          console.log(error);
        });
      // // 通过空间 id 获取到 空间 name
      // spaceServe
      //     .getData((this.formData as any).spaceId)
      //     .then((res: any) => {
      //       if (res.code === '200' && res.data !== null) {
      //         this.$set(this.formData, 'spaceName', res.data.name);
      //       }
      //     })
      //     .catch(() => {
      //       this.$message.error('获取数据失败,请稍后重试!');
      //     });
      // // 通过上级机构的 id 获取到 上级机构的名称
      // institutionServer
      //     .getData((this.formData as any).pid)
      //     .then((res: any) => {
      //       if (res.code === '200' && res.data !== null) {
      //         this.$set(this.formData, 'superName', res.data.name);
      //       }
      //     })
      //     .catch(() => {
      //       this.$message.error('获取数据失败,请重试!');
      //     });
    } else if (this.pageFlag === 3) {
      this.showWhatFlag = false;
      // 获取到该行机构的名称,然后传递给下级机构
      await institutionServer
        .getData(this.row)
        .then((res: any) => {
          if (res.code === '200') {
            (this.formData as any).superName = res.data.name; // 上级机构名称显示
            (this.formData as any).pid = res.data.id; // 将该行的id 作为新机构的 pid
          }
        })
        .catch(() => {
          this.$message.error('获取数据失败,请稍后重试!');
        });
    }
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 定义 表单  sort权重排序的验证规则
   * @param1 rule： 暂不清楚
   * @param2 value: input 中的值
   * @param3 callback: 回调
   * @returns 如果 value 是空的和number类型 就正常返回，否则报错
   */
  sortValidator(rule: any, value: any, callback: any) {
    if (value !== null && value.toString().length > 9) {
      return callback(new Error('正整数只能小于9位'));
    }
    if (value === '') {
      return callback(new Error('必填信息'));
    }
    if (value < 0) {
      return callback(new Error('请输入一个正整数'));
    }
    return typeof value === 'number' ? callback() : callback(new Error('请输入一个正整数'));
  }

  /**
   * @desc 点击保存按钮触发，保存内容
   * @param1 暂无
   * @returns 暂无
   */
  save() {
    if (!this.antiShake) {
      return;
    }
    // 开启防抖
    this.antiShake = false;
    (this.$refs.formRef as any).validate((valid: any) => {
      if (valid) {
        // 修改岗位
        if (this.pageFlag === 2) {
          professionServer
            .editData({ ...this.formData })
            .then((res: any) => {
              if (res.code === '200') {
                this.$message.success('保存成功');
                this.close(); // 跳转到 index 页面
                this.antiShake = true; // 关闭防抖
              }
            })
            .catch(() => {
              this.$message.error('保存失败,请稍后重试!');
              this.antiShake = true; // 关闭防抖
            });
        } else if (this.pageFlag === 3) {
          // 新增岗位
          professionServer
            .addData({ ...this.formData })
            .then((res: any) => {
              if (res.code === '200') {
                this.$message.success('新增岗位成功!');
                this.close(); // 跳转到 index 页面
                this.antiShake = true; // 关闭防抖
              }
            })
            .catch(() => {
              this.$message.error('新增岗位失败,请稍后重试!');
              this.antiShake = true; // 关闭防抖
            });
        }
      } else {
        this.antiShake = true; // 关闭防抖
        return false;
      }
    });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 每次点击树节点都会触发的事件，获得当前点击的id
   * @param1 data: 被点击的节点数据对象
   * @returns 暂无
   */
  handleNodeClick(data: any) {
    // 取消被选中的 树节点。
    (this.$refs.dialogTreeRef as any).store._getAllNodes().forEach((item: any, i: number) => {
      if (item.data !== data) {
        (this.$refs.dialogTreeRef as any).getNode(item.data.id).isCurrent = false;
      }
    });
    this.checkNode = data; // 选中的节点数据
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击上级机构的 input 触发事件，打开被选中的树节点。
   * @param1 tree: 树节点对象
   * @param2 name: 用于进行判断的名称
   * @returns 返回值描述
   */
  openCheckedTree(tree: any, name: string) {
    tree.forEach((item: any) => {
      if (item.name === name) {
        (this.$refs.dialogTreeRef as any).getNode(item.id).isCurrent = true;
        (this.$refs.dialogTreeRef as any).getNode(item.id).parent.expanded = true;
      } else if (item.children) {
        this.openCheckedTree(item.children, name);
      }
    });
  }

  /**
   * @desc 监听器,用于监听 dialog 中搜索框的内容.
   * @param1 暂无
   * @returns 暂无
   */
  @Watch('searchOrgan')
  searchSpace() {
    if (this.dialogTitle === '空间名称') {
      // 获取 空间树结构
      spaceServe
        .getAllData({ name: this.searchOrgan })
        .then((res: any) => {
          if (res.code === '200') {
            this.treeData = arrayToTree(res.data);
          }
        })
        .catch(() => {
          this.$message.error('获取数据失败,请稍后重试!');
        });
    } else if (this.dialogTitle === '上级机构') {
      // 获取上级机构的 treedata
      institutionServer
        .getAllData({ name: this.searchOrgan })
        .then((res: any) => {
          if (res.code === '200') {
            const obj = arrayToTree(res.data);
            this.forEachTree(obj);
            this.treeData = obj;
            console.log(obj);
          }
        })
        .catch(() => {
          this.$message.error('获取数据失败,请稍后重试!');
        });
    }
  }

  /**
   * @desc 打开dialog 弹框,显示被选择的树节点。
   * @param1 data：表单数据
   * @returns 暂无
   */
  async openDialog(data: any) {
    this.dialogTitle = '空间名称';
    this.dialogVisible = true;
    // 获取 空间树结构
    await spaceServe
      .getAllData({})
      .then((res: any) => {
        if (res.code === '200') {
          this.treeData = arrayToTree(res.data);
        }
      })
      .catch(() => {
        this.$message.error('获取数据失败,请稍后重试!');
      });
    // 打开树的一级目录
    Vue.nextTick(() => {
      (this.$refs.searchOrganRef as any).focus();
      // 打开被选中的树
      this.openCheckedTree(this.treeData, data);
    });
  }

  /**
   * @desc 打开 dialog 弹框，显示 上级机构的树节点。
   * @param1 data：表单数据
   * @returns 返回值描述
   */
  async openSuperDialog(data: any) {
    this.dialogTitle = '上级机构';
    this.dialogVisible = true;
    // 获取 上级机构的树结构
    await institutionServer
      .getAllData({})
      .then((res: any) => {
        if (res.code === '200') {
          // 判断删除当前机构的名称，上级机构不能是当前机构.
          const obj = arrayToTree(res.data);
          this.forEachTree(obj); // 得到需要删除的 index
          this.treeData = obj;
        }
      })
      .catch(() => {
        this.$message.error('获取数据失败,请稍后重试!');
      });
    // 打开树的一级目录
    Vue.nextTick(() => {
      (this.$refs.searchOrganRef as any).focus();
      this.openCheckedTree(this.treeData, data);
    });
  }

  /**
   * @desc 深度循环树节点，去除当前机构的名称。
   * @param1 data：要循环的数据
   * @returns 暂无
   */
  forEachTree(data: any[]) {
    data.forEach((item: any, index: number) => {
      if (item.id === (this.formData as any).id) {
        data.splice(index, 1);
      }
      if (item.children) {
        this.forEachTree(item.children);
      }
    });
  }

  /**
   * @desc dialog 中的确定按钮触发, 选中的值赋值给表单.
   * @param1 暂无
   * @returns 暂无
   */
  submitSpace() {
    // 赋值给 formdata 需要的数据
    if (this.dialogTitle == '空间名称' && this.checkNode) {
      console.log(this.checkNode);
      (this.formData as any).spaceName = (this.checkNode as any).name; // 空间 name
      (this.formData as any).spaceId = (this.checkNode as any).id; // 空间 id
      (this.formData as any).spaceCode = (this.checkNode as any).code; // 空间 code
    } else if (this.dialogTitle == '上级机构' && this.checkNode) {
      (this.formData as any).superName = (this.checkNode as any).name; // 上级机构的 name
      (this.formData as any).pid = (this.checkNode as any).id; // 上级机构的 id
    }
    this.dialogVisible = false;
  }

  /**
   * @desc 清除上级机构的内容
   * @param1 暂无
   * @returns 暂无
   */
  clear() {
    // 上级机构的 name为空
    this.$set(this.formData, 'superName', '');
    (this.formData as any).pid = ''; // 上级机构的 id 为空
    this.closeDialog();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 关闭 dialog
   * @param1 暂无
   * @returns 暂无
   */
  closeDialog() {
    this.dialogVisible = false;
    this.searchOrgan = ''; // 将dialog 中的input 清空
    (this.checkNode as any) = null; // 清空选中的节点对象
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 函数描述
   * @param state - 模板状态 1-开始状态 2-结束状态
   * @returns 返回值描述
   */
  close() {
    this.pageFlag = 1; // 跳转到index页面
  }
}
